import React from "react";
import { Logo } from "../Logo";
import { Divider } from "../Divider";
import { Container } from "../Container";
import { Title } from "../Title";

const Maintenance = () => {
  return (
    <div>
      <div className="flex max-w-6xl mx-auto p-4 md:px-8 py-6">
        <Logo full />
      </div>
      <Divider className="m-0 p-0" />
      <Container className="pt-16">
        <Title>Maintenance Underway</Title>
        <p className="text-lg">
          We&apos;re performing scheduled maintenance to improve your
          experience. We&apos;ll be back shortly. Thank you for your patience!
        </p>
        <div className="flex flex-row items-center">
          <p className="text-2xl">⏰</p>
          <p className="text-lg my-4 ml-2">
            Time: Aug 28th, 6:00 AM ~ 6:30 AM (UTC)
          </p>
        </div>
        <p className="text-lg font-semibold">
          If you have an urgent matter, please don&apos;t hesitate to contact us
          at: help@gowithguide.com
        </p>
      </Container>
    </div>
  );
};

export default Maintenance;
